import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export const STATUS_LABELS = {
  intake_pending: { en: "Intake pending", es: "Cuestionario pendiente" },
  intake_received: { en: "Intake received", es: "Cuestionario recibido" },
  materials_under_review: { en: "Materials under review", es: "Materiales en revisión" },
  strategy_in_progress: { en: "Strategy in progress", es: "Estrategia en curso" },
  first_direction_ready: { en: "First direction ready", es: "Primera dirección lista" },
  adjustments_in_progress: { en: "Adjustments in progress", es: "Ajustes en curso" },
  final_delivery: { en: "Final delivery", es: "Entrega final" },
  next_step_recommended: { en: "Next step recommended", es: "Próximo paso recomendado" },
};

export const STATUS_ORDER = Object.keys(STATUS_LABELS);
